<template>
    <div>
        <pageCard v-if="!flag" pagename='工程案例' desc='PROJECT CASSES' bg='al-top.png'/>
        <router-view />
    </div>
</template>

<script>

import pageCard from '../../components/page-card/index'
import {mapState} from 'vuex';
export default {
    components : {
        pageCard
    },
        computed:mapState({
        flag : state => state.flag
    }),
}
</script>